import { productsPreloader } from "@/data/preloader-data";
import React from "react";
const HeroSliderPreloader = () => {
  return (
    <>
      
        <div className="swiper-slides">
          <div
            className="bd-singel__product-banner product-thumb-bg-2 mb-30 og-div-bg"
            style={{ backgroundImage: `url("../../img/loadding/banner-main-.png")` }}
          >
            <div className="bd-product__banner-inner  product__content-4">
              <div className="bd-product__banner-content"></div>
            </div>
          </div>
        </div>
      
    </>
  );
};

export default HeroSliderPreloader;
